<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Subscriptions</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <div id="pricing-table" v-if="products.length > 0">
        <b-card-group deck>
          <b-card body-class="d-flex flex-column">
            <b-card-title>
              <h2 class="mb-0 text-center"><b-badge class="px-4 py-2">Free Forever</b-badge></h2>
            </b-card-title>
            <b-card-text>
              <h2 class="text-center">Free/month*</h2>
              <p class="text-center small">billed at $Free/yr</p>
              <div class="text-center my-3">
                <div v-if="subscription == null"><i class="fas fa-2x fa-check text-success my-2"></i></div>
                <b-button block variant="success" @click="changePlan(subscriptions[0])" v-else>Select</b-button>
              </div>
              <ul class="pl-4">
                <li>Input Unlimited Listings & Transactions</li>
                <li>Add 25 People to Pipeline Report</li>
                <li>Profit Based Economic Model (current & following year)</li>
                <li>CEO Monthly Summary Reports</li>
              </ul>
              <hr />
              <h3 class="pl-2">*Full Business+ features are free for 30 days. Free forever features are, well, free forever.</h3>
            </b-card-text>
          </b-card>

          <b-card body-class="d-flex flex-column">
            <b-card-title>
              <h2 class="mb-0 text-center"><b-badge class="px-4 py-2">Pro</b-badge></h2>
            </b-card-title>
            <b-card-text>
              <h2 class="text-center">${{ products[0].monthly_price.price / 100 }}/month</h2>
              <p class="text-center small">billed at ${{ products[0].yearly_price.price / 100 }}/year</p>
              <div class="text-center my-3">
                <div v-if="subscribedBasic"><i class="fas fa-2x fa-check text-success my-2"></i></div>
                <b-button block variant="success" @click="changePlan(products[0])" v-else>Select</b-button>
              </div>
              <p class="text-center small text-danger" v-if="affiliate"><strong>50% Off first 3 months</strong></p>
              <ul class="pl-4">
                <li>All the <strong>Free</strong> features, plus</li>
                <li>Unlimited Pipeline Additions</li>
                <li>Unlimited Users (edit and view only)</li>
              </ul>
              <h5 class="pl-2">ENHANCED BUSINESS PLANNING</h5>
              <ul class="pl-4">
                <li>Profit Based Economic Model - 5 years out</li>
                <li>Budget Model - 5 years out</li>
                <li>Lead Gen Model - 5 years out</li>
              </ul>
              <h5 class="pl-2">ENHANCED PRODUCTION TOOLS</h5>
              <ul class="pl-4">
                <li>Daily Tracking</li>
                <li>Expense Logs</li>
              </ul>
              <h5 class="pl-2">ENHANCED CEO TOOLS & REPORTS</h5>
              <ul class="pl-4">
                <li>Add Users (agents/editor/viewer)</li>
                <li>Production Goal/Gap Planning and Reporting</li>
                <li>Agent Summary Reports</li>
                <li>Projected Net Profit Reports</li>
                <li>Year-Over-Year Reports</li>
                <li>Profit & Loss Report</li>
              </ul>
              <h5 class="pl-2">ENHANCED TEAM COMMUNICATION</h5>
              <ul class="pl-4">
                <li>Tag & Update Team Members</li>
                <li>Add Important Notes in Agents' Pipelines</li>
              </ul>
              <h5 class="pl-2">PLUS</h5>
              <ul class="pl-4">
                <li>Access the ClarityNOW Community - Coming Soon</li>
                <li>Live Support</li>
              </ul>
              <hr />
              <h3 class="pl-2">Additional Pro agent portals: $10/each</h3>
            </b-card-text>
          </b-card>

          <b-card body-class="d-flex flex-column">
            <b-card-title>
              <h2 class="mb-0 text-center"><b-badge class="px-4 py-2">Business+</b-badge></h2>
            </b-card-title>
            <b-card-text>
              <h2 class="text-center">${{ products[1].monthly_price.price / 100 }}/month</h2>
              <p class="text-center small">billed at ${{ products[1].yearly_price.price / 100 }}/year</p>
              <div class="text-center my-3">
                <div v-if="subscribedStandard"><i class="fas fa-2x fa-check text-success my-2"></i></div>
                <b-button block variant="success" @click="changePlan(products[1])" v-else>Select</b-button>
              </div>
              <p class="text-center small text-danger" v-if="affiliate"><strong>50% Off first 3 months</strong></p>
              <ul class="pl-4">
                <li>All the <strong>Pro</strong> features, plus</li>
              </ul>
              <h5 class="pl-2">ENHANCED PRODUCTION TOOLS</h5>
              <ul class="pl-4">
                <li>Custom Lead Source Tracking</li>
              </ul>
              <h5 class="pl-2">ENHANCED CEO TOOLS & REPORTS</h5>
              <ul class="pl-4">
                <li>Conversion Reports</li>
                <li>Agent Production Reports</li>
                <li>Lead Source Reports</li>
                <li>Vendor Reports</li>
              </ul>
              <hr />
              <h3 class="pl-2">Additional Business+ agent portals: $5/each</h3>
            </b-card-text>
          </b-card>
        </b-card-group>
      </div>
      <div v-else>
        <loading-panel></loading-panel>
      </div>
    </b-container>
    <b-modal id="change-plan" title="Change Subscription Plan" hide-footer @hidden="resetModal" @show="checkSub">
      <h2 class="text-center" v-if="selected">{{ selected.name }}</h2>
      <base-input label="Select Plan:" label-for="plan" v-if="selected && selected.name !== 'Free'">
        <el-select v-model="plan" required>
          <el-option :value="selected.monthly_price.id" :label="'$' + selected.monthly_price.price / 100 + ' Monthly'"></el-option>
          <el-option :value="selected.yearly_price.id" :label="'$' + selected.yearly_price.price / 100 + ' Yearly'"></el-option>
        </el-select>
      </base-input>
      <base-input label="Coupon Code:" label-for="coupon" v-if="selected && selected.name !== 'Free'">
        <b-input-group>
          <b-form-input class="form-control" v-model="promocode" :state="valid_coupon"></b-form-input>
          <b-input-group-append>
            <b-button variant="success" @click="checkCoupon">Apply</b-button>
          </b-input-group-append>
        </b-input-group>
        <b-form-text id="input-live-help" v-if="valid_coupon == false"><span class="text-danger">Invalid coupon code.</span></b-form-text>
        <b-form-text id="input-live-help" v-if="valid_coupon"><span class="text-success">Coupon has been applied successfully.</span></b-form-text>
      </base-input>
      <div v-if="defaultCard || !subscription" class="text-center">
        <div v-if="updatePayment">
          <validation-observer v-slot="{handleSubmit}" ref="formValidator">
            <b-form role="form">
              <b-row>
                <b-col>
                  <label for="card-holder-name" class="sr-only sr-only-focusable">Name on Card</label>
                  <base-input name="Name on Card"
                              placeholder="Card Holder Name"
                              rules="required"
                              v-model="name">
                  </base-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div id="card-element" class="form-control"></div>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col cols="12">
                  <base-input :rules="{ required: { allowFalse: false } }" name="Privacy Policy">
                    <b-form-checkbox v-model="auto_renewal">
                      <span class="text-muted">I agree with the <a href="https://www.claritynowre.com/privacy-policy" target="_blank">Privacy Policy</a></span>
                    </b-form-checkbox>
                  </base-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <small class="text-danger">
                    Automatic Renewal Notice: Your ClarityNOW membership will automatically renew every month and your membership will continue until you cancel. No minimum purchase required. Your credit card or selected payment method will be used for your membership, and will continue to be used monthly. You can cancel your membership or change your selected payment method at any time.
                  </small>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </div>
        <b-button block variant="success" class="mt-3" :disabled="disabled" @click="submit">Submit</b-button>
        <b-button block variant="secondary" @click="updateCardInfo" v-if="defaultCard">Update Payment Method</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import {Select, Option} from 'element-ui';
import errorsMixin from "@/mixins/errors-mixin";
import LoadingPanel from '@/components/LoadingPanel';

export default {
  mixins: [errorsMixin],
  components: {
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    LoadingPanel
  },
  data() {
    return {
      subscriptions: [
        {
          name: 'Free',
          plans: []
        },
        {
          name: 'Basic',
          plans: [
            {
              name: 'monthly',
              price: '$49'
            },
            {
              name: 'yearly',
              price: '$539'
            }
          ]
        },
        {
          name: 'Standard',
          plans: [
            {
              name: 'monthly',
              price: '$99'
            },
            {
              name: 'yearly',
              price: '$1,089'
            }
          ]
        },
        {
          name: 'Premium',
          plans: [
            {
              name: 'monthly',
              price: '$149'
            },
            {
              name: 'yearly',
              price: '$1,639'
            }
          ]
        }
      ],
      stripeAPIToken: '',
      intentToken: '',
      stripe: '',
      elements: '',
      card: '',
      coupon: null,
      valid_coupon: null,
      selected: null,
      updatePayment: false,
      name: null,
      payment_method: null,
      auto_renewal: false,
      disabled: true,
      plan: null,
      products: [],
      promocode: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'profile/user',
      userRoute: 'profile/userRoute',
      affiliate: 'profile/affiliate'
    }),
    subscription() {
      return this.user.subscription;
    },
    subscribedBasic() {
      return this.products[0].id == this.subscription;
    },
    subscribedStandard() {
      return this.products[1].id == this.subscription;
    },
    subscribedPremium() {
      return this.products[2].id == this.subscription;
    },
    defaultCard() {
      if(this.user.card_brand) {
        return this.user.card_brand + ' ending in ' + this.user.card_last_four;
      }

      return null;
    }
  },
  methods: {
    changePlan(plans) {
      if (plans.name == 'Free') {
        this.disabled = false;
      } else {
        this.disabled = true;
      }

      this.selected = plans;
      this.$bvModal.show('change-plan');
    },
    updateCardInfo() {
      this.getStripeKey();
      this.updatePayment = true;
      this.disabled = true;
    },
    cancelUpdateCard() {
      this.updatePayment = false;
    },
    async getPlans() {
      axios.get(this.userRoute + "/payment-setup")
      .then(response => {
        this.intentToken = response.data.intent;
        this.products = response.data.plans;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getStripeKey() {
      axios.get(process.env.VUE_APP_API_BASE_URL + '/stripe-key')
      .then(response => {
        this.stripeAPIToken = response.data;
        this.includeStripe('js.stripe.com/v3/', function(){
          this.configureStripe();
        }.bind(this));
      })
      .catch(error => {
        this.error(error);
      });
    },
    submit() {
      if(this.updatePayment) {
        this.submitPaymentMethod();
      } else {
        this.subscribe();
      }
    },
    async submitPaymentMethod() {
      this.disabled = true;
      this.addPaymentStatus = 1;

      this.stripe.confirmCardSetup(
        this.intentToken.client_secret, {
          payment_method: {
            card: this.card,
            billing_details: {
                name: this.name
            }
          }
        }
      ).then(result => {
        if (result.error) {
          this.addPaymentStatus = 3;
          this.addPaymentStatusError = result.error.message;
          this.disabled = false;
        } else {
          this.payment_method = result.setupIntent.payment_method;
          this.subscribe();
        }
      });
    },
    async subscribe() {
      axios.post(this.userRoute + "/subscribe", {
        payment_method: this.payment_method,
        plan: this.plan,
        promocode: this.coupon,
        apply_now: true
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: 'Subscription Created Successfully',
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.$store.dispatch("profile/user").then(() => {
            this.$store.dispatch("teams/get", {user: this.user.slug});
            this.$store.dispatch("teams/member", {user: this.user.slug});
            this.resetModal();
            this.$bvModal.hide('change-plan');
          });
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    includeStripe(URL, callback){
      let documentTag = document, tag = 'script',
          object = documentTag.createElement(tag),
          scriptTag = documentTag.getElementsByTagName(tag)[0];
      object.src = '//' + URL;
      if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
      scriptTag.parentNode.insertBefore(object, scriptTag);
    },
    configureStripe(){
      this.stripe = Stripe(this.stripeAPIToken);

      this.elements = this.stripe.elements();
      this.card = this.elements.create('card');

      this.card.mount('#card-element');
    },
    resetModal() {
      this.stripeAPIToken = '';
      this.intentToken = '';
      this.stripe = '';
      this.elements = '';
      this.card = '';
      this.updatePayment = false;
      this.disabled = true;
      this.selected = false;
      this.plan = null;
      this.coupon = null;
      this.valid_coupon = null;
      this.promocode = null;
    },
    checkSub() {
      if(!this.defaultCard && !this.subscription) {
        this.updateCardInfo();
      }
    },
    async checkCoupon() {
      await axios.post(process.env.VUE_APP_API_BASE_URL + "/stripe/validate-promocode", {
        promocode: this.promocode
      })
      .then(response => {
        if (response.data == false) {
          this.valid_coupon = false;
        } else {
          this.valid_coupon = true;
          this.coupon = response.data;
        }
      })
      .catch(error => {
        // 
      });
    }
  },
  created() {
    this.getPlans();
  },
  mounted() {
    document.title = 'Subscriptions | ClarityNOW';
  },
  watch: {
    plan(to, from) {
      this.disabled = false;
    }
  }
};
</script>